import React, { useContext, useEffect, useMemo } from 'react'
import * as classes from './CorporateGovernance.module.scss'
import cn from 'classnames'
import Container from '../../ui/Container/Container'
import { deleteHtmlTag } from '../../../utils/deleteHtmlTag'
import { FormContext } from '../../../context'
import splitRow from '../../../utils/splitRow'
import { startAnimationScroll } from '../../../utils/animations'
import splitTitleV2 from '../../../utils/splitTitleV2'
import { useTab } from './useTab'
import Item from './Item'

function CorporateGovernance({ data, lang }) {
    const { animationStart } = useContext(FormContext)

    const title = useMemo(() => deleteHtmlTag(data.title?.value, 'p'), [data.title])
    const text = useMemo(() => deleteHtmlTag(data.text?.value, 'p'), [data.text])

    const { activeTab, onChangeActiveTab, resultDataTabs, onFormatBytes } = useTab(data)

    const classAnimationTitle = 'anime-title-governance-brief'
    const classAnimationText = 'anime-text-governance-brief'

    useEffect(() => {
        if (animationStart) {
            splitRow(classAnimationText)
            splitTitleV2(classAnimationTitle)
        }

        const observer = startAnimationScroll([
            { type: 'text', className: classAnimationText },
            { type: 'title', className: classAnimationTitle }
        ])

        return () => {
            if (observer) {
                observer.disconnect()
            }
        }
    }, [animationStart])

    return (
        <section className={cn(classes.Section, { [classes.LangHY]: lang === 'hy' })}>
            <Container>
                {title || text ? (
                    <div className={classes.Header}>
                        {title ? <h2 className={`${classes.Title} ${classAnimationTitle}`} dangerouslySetInnerHTML={{ __html: title }} /> : null}

                        {text ? <p className={`${classes.Desc} ${classAnimationText}`} dangerouslySetInnerHTML={{ __html: text }} /> : null}
                    </div>
                ) : null}

                <div className={classes.Inner}>
                    {resultDataTabs?.length > 0 && (
                        <div className={classes.Tabs}>
                            {resultDataTabs.map((tab) => (
                                <button
                                    className={cn(classes.Tab, { [classes.Active]: tab.id === activeTab?.id })}
                                    key={tab.id}
                                    onClick={() => onChangeActiveTab(tab)}
                                >
                                    {tab.title}
                                </button>
                            ))}
                        </div>
                    )}

                    {activeTab?.items?.length > 0 && (
                        <div className={classes.Content + ' js-governance-content '}>
                            <Item files={activeTab.items} onFormatBytes={onFormatBytes} lang={lang} />
                        </div>
                    )}
                </div>
            </Container>
        </section>
    )
}

export default CorporateGovernance
